import {
  eventBus,
  INTERNAL_EVENTS,
  useBaseStore,
} from '@cometchat/calls-sdk-core';
import JitsiMeetJS from '../../../calls-sdk-core/lib-jitsi-meet';

eventBus.subscribe(INTERNAL_EVENTS.onConnectionEstablished, () => {
  useBaseStore.setState({
    isDesktopSharingEnabled: JitsiMeetJS.isDesktopSharingEnabled(),
  });

  {
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');

    const isBlurSupported = typeof ctx?.filter !== 'undefined';

    useBaseStore.setState({ isBlurSupported });

    canvas.remove();
  }
});
